var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "intLogo 1",
    clipPath: "url(#clip0_116_362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5579 40.0191C30.3594 40.0191 39.1158 31.2627 39.1158 20.4612C39.1158 9.65971 30.3594 0.903351 19.5579 0.903351C8.75636 0.903351 0 9.65971 0 20.4612C0 31.2627 8.75636 40.0191 19.5579 40.0191Z",
    fill: "#1A509E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.70312 15.3175H10.9718V25.116H8.70312V15.3175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4157 15.3175V25.116H19.5578L14.7074 19.1704V25.116H12.4778V15.3175H14.3358L19.1862 21.2631V15.3175H21.4157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8749 17.2537H23.1368V15.4349H30.608V17.2537H27.8698V25.0964H25.8749V17.2537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0602 25.1746C30.6218 25.1746 31.0772 24.7193 31.0772 24.1576C31.0772 23.5959 30.6218 23.1406 30.0602 23.1406C29.4985 23.1406 29.0432 23.5959 29.0432 24.1576C29.0432 24.7193 29.4985 25.1746 30.0602 25.1746Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.1157,
    height: 39.1157,
    fill: "white",
    transform: "translate(0 0.903351)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntLogo1);
export default __webpack_public_path__ + "static/media/intLogo_1.0c635ab6232e8e27b463aee1cfda2678.svg";
export { ForwardRef as ReactComponent };